var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-banner',{staticClass:"errorBox text-negative theme-bg-gray q-pa-md"},[_c('div',{staticClass:"error border-radius-8 q-pa-sm text-left"},[_c('q-icon',{attrs:{"name":"error","size":"24px","color":"negative"}}),_c('span',{staticClass:"font-size-16 q-ml-xs"},[_vm._v(" Error detail")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }